module.exports = __webpack_public_path__ + "img/az.94860048.svg";